import { render } from "./ReportarIncidenciaStreamlined.vue?vue&type=template&id=34a76455&scoped=true"
import script from "./ReportarIncidenciaStreamlined.vue?vue&type=script&lang=ts"
export * from "./ReportarIncidenciaStreamlined.vue?vue&type=script&lang=ts"

import "./ReportarIncidenciaStreamlined.vue?vue&type=style&index=0&id=34a76455&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34a76455"

export default script